// Shared labels, tones and formatters of the crew import screens.

export const IMPORT_STATUS = {
  parsing: { label: 'Reading file', tone: 'blue' },
  uploaded: { label: 'Uploaded', tone: 'neutral' },
  mapped: { label: 'Mapped', tone: 'blue' },
  diff_building: { label: 'Building preview', tone: 'blue' },
  diff_ready: { label: 'Preview ready', tone: 'green' },
  blocked: { label: 'Blocked', tone: 'red' },
  applying: { label: 'Applying', tone: 'blue' },
  applied: { label: 'Applied', tone: 'green' },
  applied_with_errors: { label: 'Applied with issues', tone: 'amber' },
  failed: { label: 'Failed', tone: 'red' },
  cancelled: { label: 'Cancelled', tone: 'neutral' }
}

export const IMPORT_MODE = {
  full: 'Full registry',
  partial: 'Partial update'
}

export const ROW_ACTION = {
  create: { label: 'Create', tone: 'green' },
  update: { label: 'Update', tone: 'blue' },
  unchanged: { label: 'Unchanged', tone: 'neutral' },
  error: { label: 'Error', tone: 'red' }
}

export const ROW_APPLY_STATUS = {
  pending: { label: 'Pending', tone: 'neutral' },
  applied: { label: 'Applied', tone: 'green' },
  skipped: { label: 'Skipped', tone: 'neutral' },
  failed: { label: 'Failed', tone: 'red' },
  conflict: { label: 'Conflict', tone: 'amber' }
}

// Statuses in which a background task owns the import and the page has to poll.
export const ACTIVE_STATUSES = ['parsing', 'diff_building', 'applying']
export const EDITABLE_STATUSES = ['uploaded', 'mapped']
export const CANCELLABLE_STATUSES = ['parsing', 'uploaded', 'mapped', 'diff_ready', 'blocked']

export function statusMeta(status) {
  return IMPORT_STATUS[status] || { label: status || '—', tone: 'neutral' }
}

export function formatDateTime(value) {
  if (!value) return '—'
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
  }).format(new Date(value))
}

export function formatDate(value) {
  if (!value) return '—'
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric'
  }).format(new Date(value))
}

export function formatNumber(value) {
  return new Intl.NumberFormat('en-GB').format(value || 0)
}

export function userName(user) {
  if (!user) return '—'
  return user.full_name || [user.first_name, user.last_name].filter(Boolean).join(' ') || `User #${user.id}`
}

export function formatValue(value) {
  if (value === null || value === undefined || value === '') return '—'
  if (Array.isArray(value)) return value.length ? value.join(', ') : '—'
  if (typeof value === 'boolean') return value ? 'Yes' : 'No'
  return String(value)
}

// "details" is the body of every 400 answer of the import API.
export function apiErrorMessage(error, fallback = 'Something went wrong. Try again.') {
  const data = error && error.response && error.response.data
  if (data && typeof data.details === 'string') return data.details
  return fallback
}

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/

// "3 changes" for the diff table; the full list opens in a window.
export function changeCountText(changes) {
  const count = Object.keys(changes || {}).length
  if (!count) return 'No changes'
  return count === 1 ? '1 change' : `${count} changes`
}

// Diff values are stored as JSON: dates arrive as ISO strings, lists as arrays.
export function formatChangeValue(value) {
  if (typeof value === 'string' && ISO_DATE.test(value)) return formatDate(value)
  return formatValue(value)
}
